// Seiteneffekt-Import: das Dashboard nutzt PA-Klassen (technician-tour.model etc.), die über
// die PARegistry auf die PA-Singletons zugreifen — Registrierung muss vor dem Zugriff passieren
import "../_components/planning-assistant/singletons/pa-singleton-bootstrap";
import { AfterViewInit, Component, ElementRef, inject, model, OnInit, ViewChild } from '@angular/core';
import { ColDef, GridReadyEvent } from "ag-grid-community";
import { OperationService, TicketService, UserService } from "../_services";
import { AG_GRID_LOCALE_DE } from "../_helpers/aggrid.locale.de";
import {
  GridApi, GridState,
  ITooltipParams,
  RowClassRules,
  SideBarDef,
  SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy
} from "ag-grid-enterprise";
import { PASettingsControl } from "../_components/planning-assistant/singletons/pa-settings-control";
import { dateFormatter } from "../_helpers/aggrid-renderer";
import { WPTicket } from "../_models/ticket.interface";
import { Router } from "@angular/router";
import { Technician } from "../_models";
import { CommonModule, formatDate } from "@angular/common";
import { WPTechnician } from "../_models/technician.interface";
import { WPOperation } from "../_models/operation.interface";
import { CapacityBarsComponent } from "./capacity-bars/capacity-bars.component";
import type { BarData, BarOption, Deadline } from "./capacity-bars/capacity-bars.model";
import { RouteVisualizationComponent } from "./route-visualization/route-visualization.component";
import type { RouteNode } from "./route-visualization/route-visualization.model";
import {
  faBell,
  faCheck,
  faChevronDown,
  faMinusCircle,
  faPhone,
  faPlusCircle, faUser,
  faWindowClose, faWrench
} from "@fortawesome/free-solid-svg-icons";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { TravelTechnicianDateService } from "../_services/travel_technician_date.service";
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  ValidationErrors, Validators
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AgGridAngular } from 'ag-grid-angular';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { AgGridThemeService } from '../_services/ag-grid-theme.service';
import { StoreCollection, TechnicianTour } from "../_models/technician-tour.model";
import { DashboardMapComponent } from "./dashboard-map/dashboard-map.component";
import { DistanceCalculator } from "../_components/planning-assistant/classes/location";
import { MapBoxService } from "../_services/mapbox.service";
import {
  MapDisplayUnit,
  StoreFeatureMapDisplayUnit,
  StoreMapboxFeatureInstance, StoreStopoverMapDisplayUnit, TechnicianMapDisplayUnit,
  TourAnimationMapDisplayUnit
} from "../_models/map-display-unit.model";
import type {
  OperationWithStore
} from "../_components/planning-assistant/reuseable-components/tour-stopover/tour-stopover.model";
import { DynamicComponentService } from "../_services/dynamic-component-service";
import { PAUtil } from "../_components/planning-assistant/classes/util";
import { DispatcherFilter } from "../_components/_shared/ag-grid-filter/ag-grid-dispatcher-filter.component";
import {
  AgGridFASymbolLinkRenderer,
  FaLinkIcon
} from "../_components/_shared/ag-grid-renderer/ag-grid-fa-symbol-links.component";
import { faEnvelope } from "@fortawesome/pro-light-svg-icons";
import { faRoute } from "@fortawesome/pro-duotone-svg-icons/faRoute";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import {
  encodePlanTechnicianLoadingCaseParams,
  encodePlanTicketsLoadingCaseParams
} from "../_components/planning-assistant/pa-loading-case-params";
import { faTicket } from "@fortawesome/pro-duotone-svg-icons/faTicket";
import { faBox } from "@fortawesome/pro-duotone-svg-icons/faBox";
import { CdkMenu, CdkMenuTrigger } from "@angular/cdk/menu";
import { AbsenceCalendar } from "../_models/absence.model";
import { Absence } from "../_models/absence.interface";
import { PATimeControl } from "../_components/planning-assistant/singletons/pa-time-control";
import { MatCard, MatCardModule } from "@angular/material/card";
import { MatCalendar, MatDatepickerModule } from "@angular/material/datepicker";
import { FlatpickrDefaultsInterface, FlatpickrModule } from "angularx-flatpickr";
import {
  AgGridFAActionSymbolRenderer, FaActionIcon
} from "../_components/_shared/ag-grid-renderer/ag-grid-fa-action-symbols.component";
import { PlanningAssistantSettingsService } from "../_components/planning-assistant/services/planning-assistant-settings.service";
import { DISPATCHER_COLORS } from "../_helpers/color-palettes";


interface OpenProject {
  id: number
  project_name: string,
  project_color: string,
  unplanned_tickets: WPTicket[]
}

interface ProjectChartData {
  name: string,
  color: string,
  count: number
}

interface AdditionalTechnicianTableData {
  tour?: TechnicianTour,
  links?: FaLinkIcon[],
  day_absence?: string,
  absence_user_id?: string,
}

const MATERIALVERSAND_PROJECT_ID = 209;

type KPIFilter = '6sla' | '0sla' | 'new' | 'qm' | 'overdue' | 'not_approached' | 'all'
type ReviewFilterSelection = 'off' | 'planned';

@Component({
  selector: 'hawk-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss', './../_components/_shared/styles/common-styles.scss'],
  imports: [CommonModule, FormsModule, CapacityBarsComponent, RouterModule, MatFormFieldModule, MatButtonModule, MatButtonToggleModule, MatSelectModule, FontAwesomeModule, AgGridAngular, RouteVisualizationComponent, MatTabsModule, DashboardMapComponent, TooltipModule, CdkMenu, CdkMenuTrigger, MatCard, MatCalendar, MatCardModule, MatDatepickerModule, ReactiveFormsModule, FlatpickrModule],
  standalone: true,
  host: {
    class: 'app-page',
  }
})
export class WelcomeComponent implements OnInit, AfterViewInit {

  @ViewChild('TableSizeObsContainer') tableSizeObsContainer: ElementRef<HTMLDivElement>;

  public hawkTheme = inject(AgGridThemeService).getTheme();
  selectedDate = model<Date | null>(new Date());

  selectedTabIdx: number = 0;
  selectedKPITile: KPIFilter = 'all'
  selectedProjects: string[] | 'all' = 'all'
  selectedReviewFilter: ReviewFilterSelection = 'off';
  selectedMaterialReviewFilter: ReviewFilterSelection = 'off';

  // Materialversand-Tab
  shownMaterialTickets: (WPTicket & {actions: FaActionIcon[]} & {dispatcher_color?: string})[] = []
  materialTicketStorageKey = 'DashboardMaterialTicketSearchStateSettings'
  initialMaterialTicketState?: GridState;

  pseudoTechnicianNames: string[] = ['offene Planung', 'Bentomax Bereitschaft', 'nicht vergeben', 'Kein Einsatz notwendig', 'Materialerfassung Kiel']
  placeholderTechnicians: Technician[] = []
  tickets: WPTicket[] = []
  activeDispatcher: Technician[] = []
  shownTickets: (WPTicket & {actions: FaActionIcon[]} & {dispatcher_color?: string})[] = []
  selectedMapStoreFeatureInstances: StoreMapboxFeatureInstance[] = []
  unSelectedMapStoreFeatureInstances: StoreMapboxFeatureInstance[] = []
  technicians: (WPTechnician & AdditionalTechnicianTableData)[] = []
  shownTechnicians: (WPTechnician & AdditionalTechnicianTableData)[] = []
  selectedTicketIds: number[] = []
  selectedTechnician: (WPTechnician & AdditionalTechnicianTableData) = null
  openProjects: OpenProject[] = []
  storeCollection = new StoreCollection()

  // Capacity Bars
  capacityBarsCollapsed = false
  technicianBarData: BarData[] = []
  capacityBarsFilter = ['Alle Aufträge abgeschlossen', 'Im letzten Auftrag', 'Ohne Auftrag'];
  capacityBarOptions: BarOption[] = [
    {
      title: 'Reisetechniker',
      tooltip: 'Wenn dieses Feld gesetzt ist, wird die Fahrtzeit der Heimreise des Technikers mit 0 Minuten berechnet.'
    }
  ]
  deadlineNow?: Deadline
  unitAmountStart = 6
  unitAmountEnd = 20

  // Route Visualization
  routeVisualizationNodes: RouteNode[] = []

  // Sideboard
  public SLA6HWarningTicketCount: number = 0
  public SLA0HWarningTicketCount: number = 0
  public newTicketCount: number = 0
  public qmTicketCount: number = 0
  public overdueTicketCount: number = 0
  public notApproachedTicketCount: number = 0

  public distanceCalculator: DistanceCalculator

  technicianGroupFilter: 'bentomax' | 'plus_external_with_operations' | 'all' = 'bentomax'

  mapTechnicianFilter: 'with_tour' | 'not_absent' | 'all' = 'not_absent';
  mapTourFilter: 'selected' | 'all' = 'all';

  pageSize: number = 20;

  protected readonly locale = AG_GRID_LOCALE_DE;
  protected readonly PASettingsControl = PASettingsControl;
  protected readonly faCheck = faCheck;

  public ticketStorageKey = 'DashboardTicketSearchStateSettings'
  public technicianStorageKey = 'DashboardTechncianSearchStateSettings'
  public initialTicketState?: GridState;
  public initialTechnicianState?: GridState;

  public ticketColDefs: ColDef[] = [
    {
      field: "id",
      headerName: "ID",
      cellRenderer: this.ticketIdRenderer,
      width: 110,
      maxWidth: 130,
      cellClass: 'hover_link_cell',
      checkboxSelection: true,
      headerCheckboxSelection: true
    },
    {
      field: "external_id",
      headerName: "Externe-ID",
      width: 140,
    },
    {
      field: "project.name",
      headerName: "Projekt",
      width: 160,
    },
    {
      field: "priority.name",
      headerName: "Prio",
      cellRenderer: this.prioCellRenderer2,
      width: 80,
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
    },
    {
      field: "sla",
      headerName: "SLA",
      valueFormatter: dateFormatter(),
      cellClassRules: {
        'sla_danger_td': function(params) {
          const hours_until_sla = (Date.parse(params.data.sla) - new Date().getTime() ) / (1000 * 3600)
          return hours_until_sla < 4;
        },
        'sla_warn_td': function(params) {
          const hours_until_sla = (Date.parse(params.data.sla) - new Date().getTime() ) / (1000 * 3600)
          return hours_until_sla < 6 && hours_until_sla >= 4;
        }
      },
      width: 150,
    },
    {
      field: "store_nr",
      headerName: "Store-Nr",
      width: 120,
      hide: true
    },
    {
      field: "store_name",
      headerName: "Store Name",
      cellRenderer: this.storeRenderer,
      cellClass: 'hover_link_cell',
      width: 120,
    },
    {
      field: "city",
      headerName: "Ort",
      width: 120,
    },
    {
      field: "state",
      headerName: "Bundesland",
      width: 100
    },
    {
      field: 'description',
      headerName: "Info",
      width: 240,
      tooltipField: 'description',
    },
    {
      field: 'review',
      headerName: "Wiedervorlage",
      width: 240,
      cellRenderer: this.reviewRenderer,
      tooltipValueGetter: params => {
        const review = params?.value
        if (review) {
          return review.reason
        }
        return ''
      }
    },
    {
      field: "date_created",
      headerName: "Erstelldatum",
      valueFormatter: dateFormatter(),
      width: 150,
      maxWidth: 150,
      hide: true,
    },
    /*{
      field: "operation_date",
      headerName: "Einsatz-Datum",
      cellRenderer: this.operationDateRenderer,
      width: 150,
      maxWidth: 150,
      tooltipField: "operation_date"
    },
    {
      field: "planned_technician_name",
      headerName: "Einsatz-Techniker",
      width: 160,
      maxWidth: 160,
      tooltipField: "planned_technician_name"
    },*/
    {
      field: "dispatcher",
      headerName: "DP",
      cellRenderer: this.dispatcherRenderer,
      maxWidth: 72,
      filter: DispatcherFilter,
      filterParams: () => ({
        dispatchers: this.activeDispatcher
      }),
      valueGetter: (params) => {
        return params.data?.dispatcher?.initials || '';
      },
      comparator: (valueA: string, valueB: string) => {
        // Sort alphabetically by initials, empty values last
        if (!valueA && !valueB) return 0;
        if (!valueA) return 1;
        if (!valueB) return -1;
        return valueA.localeCompare(valueB);
      }
    },
    {
      field: "actions",
      headerName: "Aktionen",
      maxWidth: 32,
      cellRenderer: AgGridFAActionSymbolRenderer,
      sortable: false,
      suppressFiltersToolPanel: true,
      filter: false
    },
  ]

  public technicianColDefs: ColDef[] = [
    {
      field: "tour",
      headerName: "Tour",
      maxWidth: 50,
      cellRenderer: (params: { value: TechnicianTour, data: WPTechnician }) => {
        if (params.value && params.value.operations?.length) {
          return `<div style="width: 24px; height: 24px; border-radius: 2px; background-color: ${params.value.color}"></div>`
        }
        return '-'
      },
      valueFormatter: (params: { value: TechnicianTour, data: WPTechnician }) => {
        if (params.value?.operations) {
          return params.value.operations.length.toString()
        }
        return null
      },
      suppressFiltersToolPanel: true,
      suppressHeaderMenuButton: true,
      filter: false
    },
    {
      field: "lastname",
      headerName: "Name",
      width: 180,
      cellRenderer: (params: { value: string, data: WPTechnician }) => {
        return `${params.value}, ${params.data.firstname}`
      }
    },
    {
      field: "city",
      headerName: "Ort",
      width: 140,
      hide: true,
    },
    /*{
      field: "email1",
      headerName: "Email",
      cellRenderer: this.emailRenderer,
      width: 260,
      cellClass: 'hover_link_cell',
    },
    {
      field: "phone1",
      headerName: "Telefon",
      cellRenderer: this.telephoneRenderer,
      width: 160,
      cellClass: 'hover_link_cell',
    },*/
    /*{
      field: "pa_url",
      headerName: "Planungsassistent",
      width: 200,
      cellRenderer: (params: { value: number }) => {
        if (params.value) {
          return `<a href="${params.value}" target="_blank">öffnen</a>`
        } else {
          return ''
        }
      },
      cellClass: 'hover_link_cell',
      sortable: false,
    },*/
    {
      field: "links",
      headerName: "Aktionen",
      maxWidth: 100,
      cellRenderer: AgGridFASymbolLinkRenderer,
      sortable: false,
      suppressFiltersToolPanel: true,
      suppressHeaderMenuButton: true,
      filter: false
    },
  ]

  autoSizeStrategy: SizeColumnsToFitGridStrategy | SizeColumnsToFitProvidedWidthStrategy | SizeColumnsToContentStrategy = {
    type: "fitGridWidth",
  }

  private ticketGridApi!: GridApi;
  private materialTicketGridApi!: GridApi;
  private technicianGridApi!: GridApi;

  public rowClassRules: RowClassRules = {}

  public sideBarOptions: SideBarDef = {
    hiddenByDefault: false,
    toolPanels: ['columns', 'filters']
  }

  public defaultColDef: ColDef = {
    filter: true
  }
  public storeFeatureMapDisplayUnits: StoreFeatureMapDisplayUnit[] = [];
  public mapTourAnimationDisplayUnits: TourAnimationMapDisplayUnit[] = []
  public storeStopOverDisplayUnits: StoreStopoverMapDisplayUnit[] = []
  public technicianMapDisplayUnits: TechnicianMapDisplayUnit[] = []
  public mapDisplayUnits: MapDisplayUnit<any[], any[]>[] = [];
  public mapNavigation: {center?: {lat: number, lng: number}, zoom?: number} = {center: { lat: 51.4, lng: 10.4476 }, zoom: 5}

  public datePickerConfig: FlatpickrDefaultsInterface = {
    enableTime: true,
    convertModelValue: true,
    altInput: true,
    allowInput: true,
    altFormat: 'd.m.Y H:i',
    dateFormat: 'Y-m-d H:i',
    defaultHour: 6,
    defaultMinute: 0,
    minuteIncrement: 5,
    time24hr: true,
    enable: [{ from: new Date(), to: new Date(new Date().getFullYear() + 50, 12) }]
  }

  firstProjectsInitialized: boolean = false;
  showTicketReviewDialogForm: UntypedFormGroup;
  reviewDialogTicket: WPTicket | null = null;

  constructor(
    private ticketService: TicketService,
    private userService: UserService,
    private router: Router,
    private travelTechnicianDateService: TravelTechnicianDateService,
    private dynamicComponentService: DynamicComponentService,
    private absenceCalendar: AbsenceCalendar,
    private formBuilder: FormBuilder,
    private planningAssistantSettingsService: PlanningAssistantSettingsService,
    mapBoxService: MapBoxService,
    operationService: OperationService
  ) {
    this.distanceCalculator = new DistanceCalculator(
      mapBoxService,
      operationService
    )

   this.selectedDate.subscribe(
     date => {
       if (date) {
         this.updateTicketAndTechnicianData()
       }
     }
   )
  }

  ngOnInit(): void {
    this.initTableStates()

    // PA-Settings laden, damit individuelle Techniker-Startzeiten verfügbar sind
    PASettingsControl.Instance.settingsService = this.planningAssistantSettingsService
    PASettingsControl.Instance.loadSettingsFromDatabase().then(_ => {
      this.absenceCalendar.loadAbsenceUsers().then( _ => {
        this.absenceCalendar.loadAbsencesBetweenDates(
          PATimeControl.Instance.dateToDatestring(
            new Date(),
            true,
            false,
            '-'
          )
        ).then( _ => {
          this.userService.placeHolderTechnicians().subscribe(
            data => {
              this.placeholderTechnicians = data

              this.userService.getDispatcher().subscribe(
                data => {
                  this.activeDispatcher = data

                  this.updateTicketAndTechnicianData()
                  setInterval(()=> { this.updateTicketAndTechnicianData() }, 5 * 60 * 1000);
                },
                error => {
                  console.log(error)
                }
              )
            },
            err => {
              console.log(err)
            }
          )
        })
      })
    })
  }

  private updateTicketAndTechnicianData(): void {
    this.updateServiceTickets();
    this.updateTechnicianData()
  }

  private updateServiceTickets() {
    this.ticketService.getOpenServiceTickets().subscribe(
      data => {
        this.tickets = data
        this.updateShownTickets()
        this.updateSideBoard()
      },
      err => {
        console.log(err)
      }
    )
  }

  ngAfterViewInit(): void {

    const table_size_observer = new ResizeObserver(entries => {
      entries.forEach(_ => {
        if (this.technicianGridApi) {
          this.technicianGridApi.sizeColumnsToFit()
        }
        if (this.ticketGridApi) {
          this.ticketGridApi.sizeColumnsToFit()
        }
        if (this.materialTicketGridApi) {
          this.materialTicketGridApi.sizeColumnsToFit()
        }
      });
    });

    table_size_observer.observe(this.tableSizeObsContainer.nativeElement);

    if (window.innerWidth <= 1920) {
      this.mapNavigation = { zoom: 4.2, center: { lat: 51.4, lng: 10.4476 } }
    }

    // resize table after 2,5 s
    (new Promise(resolve => setTimeout(resolve, 2500))).then(
      _ => this.ticketGridApi.sizeColumnsToFit()
    );
  }

  private updateTechnicianData(): void {
    this.updateTechnicians()
  }

  private async updateTechnicians() {
    await new Promise<void>(resolve => {
      const selected_date = this.selectedDate()
      this.userService.getUsersWPHashes(
        selected_date ? PATimeControl.Instance.dateToDatestring(selected_date,true,false,'-') : undefined
      ).subscribe(
        data => {
          this.technicians = data.filter(
            t => !this.pseudoTechnicianNames.includes(t.full_name) && !this.placeholderTechnicians.find(pl_t => pl_t.id == t.id)
          ).sort(
            (ta, tb) => ta.lastname < tb.lastname ? -1 : 1
          )

          this.technicians.map(
            t => {
              t.absence_user_id = this.absenceCalendar.getAbsenceUserIdByMail(t.email1)
                || this.absenceCalendar.getAbsenceUserIdByMail(t.email2)
                || this.absenceCalendar.getAbsenceUserIdByFullName(t.full_name)
            }
          )

          this.updateTechnicianAbsences().then(_ => {
            this.updateShownTechnicians().then(_ => {
              resolve()
            })
          })
        },
        error => {
          console.log(error)
          resolve()
        }
      )
    })

  }

  private async updateTechnicianAbsences() {
    await Promise.all(
      this.technicians.map(
        async technician => {
          const technician_absences = this.getSelectedDatesTechnicianAbsences(technician)
          const regional_public_holidays = this.getSelectedDatesRegionalTechnicianHolidays(technician).filter(hd => hd.type == 'public')

          if (regional_public_holidays.length) {
            technician.day_absence = regional_public_holidays[0].name
          } else if (technician_absences.length) {
            const reason_id = technician_absences[0].reasonId
            await this.absenceCalendar.waitForReason(reason_id)
            technician.day_absence = this.absenceCalendar.reasonMap.get(reason_id).name
          } else {
            const selected_date = this.selectedDate()
            const absence_user = this.absenceCalendar.absenceUserMap.get(technician.absence_user_id)
            if (absence_user && selected_date) {
              const selected_local_day_ts = PATimeControl.Instance.dateToTimestamp(selected_date, true, false)
              const weekday = PATimeControl.Instance.getTimeStampsWeekDay(selected_local_day_ts)
              if (PATimeControl.Instance.workDays.includes(weekday) && !absence_user.hasShiftOnWeekdayWithFallback(weekday, selected_local_day_ts)) {
                technician.day_absence = `Keine Schicht am ${PATimeControl.Instance.weekDayToGermanName(weekday, false)}`
              }
            }
          }
        }
      )
    )
  }

  updateSideBoard(): void {
    this.updateSLAWarnings()
    this.updateCharts()
  }

  updateSLAWarnings(): void {
    this.SLA0HWarningTicketCount = this.filterTicketsForTimeUntilSLA(this.tickets, 0).length
    this.SLA6HWarningTicketCount = this.filterTicketsForTimeUntilSLA(this.tickets, 6 * 60 * 60 * 1000, true).length
  }

  filterTicketsForTimeUntilSLA(tickets: WPTicket[], time_ms: number, cut_at_0?: boolean): WPTicket[] {
    const timestamp_now = new Date().getTime();
    return tickets.filter(ti => {
      if (!ti.sla) return false

      const sla_ts = new Date(ti.sla).getTime()
      if (ti.date_finished && sla_ts >= new Date(ti.date_finished).getTime()) return false

      const threshold_time = sla_ts - time_ms
      return (threshold_time < timestamp_now) && (!cut_at_0 || sla_ts > timestamp_now)
    })
  }

  updateCharts(): void {
    const new_tickets = this.filterNewTickets(this.tickets)
    const qm_tickets = this.filterQMTickets(this.tickets)
    const overdue_tickets = this.filterOverdueTickets(this.tickets)
    const not_approached_tickets = this.filterNotApproachedTickets(this.tickets)

    this.newTicketCount = new_tickets.length
    this.qmTicketCount = qm_tickets.length
    this.overdueTicketCount = overdue_tickets.length
    this.notApproachedTicketCount = not_approached_tickets.length
  }

  filterNewTickets(tickets: WPTicket[]): WPTicket[] {
    return tickets.filter(ticket => this.ticketIsNew(ticket))
  }

  filterQMTickets(tickets: WPTicket[]): WPTicket[] {
    return tickets.filter(ticket => ticket.qm_jobs.length > 0)
  }

  filterOverdueTickets(tickets: WPTicket[]): WPTicket[] {
    return tickets.filter(ticket =>
      {
        if (!ticket.operation_date) return false

        const ts_now = new Date().getTime()
        const ts_operation_date = new Date(ticket.operation_date).getTime()
        if (ts_now <= ts_operation_date) {
          return false
        } else {
          return !ticket.date_on_site || !(new Date(ticket.date_on_site).getTime() > ts_operation_date)
        }
      }
    )
  }

  filterNotApproachedTickets(tickets: WPTicket[]): WPTicket[] {
    return tickets.filter(ticket => !this.ticketIsUnplanned(ticket) && !ticket.date_travel_start)
  }

  /*ticketsToProjectPieChart(tickets: WPTicket[], chart_id: string, kpi_filter: KPIFilter): Chart<'pie', number[], string> {
    const chart_data = this.getTicketsProjectChartData(tickets)
    return new Chart(chart_id, {
      type: 'pie',
      data: {
        labels: chart_data.map(data => data.name),
        datasets: [{
          label: 'Anzahl',
          data: chart_data.map(data => data.count),
          backgroundColor: chart_data.map(data => data.color),
          borderColor: chart_data.map(data => 'white'),
          borderWidth: 2,
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false
          }
        },
        borderColor: 'rgb(236,236,236)',
        spacing: 1,
        'onClick' : (evt, item)=>  {
          let dataIndex = item[0].index;
          let label = evt['chart'].data.labels[dataIndex];
          this.clickProject(label)
          if (this.selectedKPITile != kpi_filter) {
            this.selectKPITile(kpi_filter)
          }
          evt.native.stopPropagation()
        }
      }
    });
  }*/

  getTicketsProjectChartData(tickets: WPTicket[]): ProjectChartData[] {
    const chart_data: ProjectChartData[] = []
    for (const project of tickets.map(ti => ti.project)) {
      if (!chart_data.find(data => data.name == project.name)) {
        const pr_tickets = tickets.filter(t => t.project.name == project.name)
        if (pr_tickets.length) {
          chart_data.push({
            name: project.name,
            color: project.color || 'rgba(125, 125, 125, 1)',
            count: pr_tickets.length,
          })
        }
      }
    }
    return chart_data
  }

  async updateShownTechnicians(): Promise<void> {
    this.shownTechnicians = this.getGroupFilteredTechnicians(this.technicians)

    await this.updateTechnicianCapacityBars()
    this.updateTechnicianTourColors()
    this.updateTourDisplayUnits()
    this.updateTechnicianMapDisplayUnits()
  }

  getSelectedDatesTechnicianAbsences(technician: WPTechnician & AdditionalTechnicianTableData): Absence[] {
    const selected_date = this.selectedDate()
    if (technician.absence_user_id && selected_date) {
      const selected_local_day_ts = PATimeControl.Instance.dateToTimestamp(selected_date, true, false)
      const date_string = PATimeControl.Instance.timestampToDatestring(selected_local_day_ts, true, '-')
      return this.absenceCalendar.getLoadedUserAbsencesOnDate(technician.absence_user_id, date_string)
    } else {
      return []
    }
  }

  getGroupFilteredTechnicians(technicians: WPTechnician[]): WPTechnician[] {
    return technicians.filter(t => {
      const is_bentomax_technician = [t.company, t.company_address_company].filter(c => c).find(c => c.toLowerCase().includes('bentomax'))

      return is_bentomax_technician
        || (this.technicianGroupFilter == 'plus_external_with_operations' && t.day_operations.length)
        || this.technicianGroupFilter == 'all'
    })
  }

  /*getDayOperationFilteredTechnicians(technicians: WPTechnician[]): WPTechnician[] {
    return technicians.filter(t => {
      return (this.technicianDayOperationFilter != 'with_day_operations') || (t.day_operations.length > 0);
    })
  }*/

  updateShownTickets(): void {
    const tickets = this.tickets

    // Materialversand-Tickets separat behandeln
    const materialTickets = tickets.filter(t => t.project.id === MATERIALVERSAND_PROJECT_ID)
    const regularTickets = tickets.filter(t => t.project.id !== MATERIALVERSAND_PROJECT_ID)

    // Materialversand-Tab: nur Wiedervorlage-Filter anwenden
    const materialReviewFiltered = this.getReviewFilteredTickets(materialTickets, this.selectedMaterialReviewFilter)
    this.shownMaterialTickets = materialReviewFiltered.map(ticket => this.mapTicketToRowData(ticket))

    // Tickets-Tab: reguläre Filter-Chain (ohne Materialversand)
    const project_filtered_tickets = this.getProjectFilteredTickets(regularTickets)
    const review_filtered_tickets = this.getReviewFilteredTickets(project_filtered_tickets);
    this.shownTickets = this.getKPIFilteredTickets(review_filtered_tickets).map(ticket => this.mapTicketToRowData(ticket))

    // Projektauswahl ohne Materialversand
    const open_projects: OpenProject[] = []
    for (const project of regularTickets.map(ti => ti.project)) {
      if (!open_projects.find(op => op.project_name == project.name)) {
        const unplanned_tickets = regularTickets.filter(t => t.project.name == project.name)
        open_projects.push({
          id: project.id,
          project_name: project.name,
          project_color: project.color,
          unplanned_tickets: unplanned_tickets
        })
      }
    }

    // Interne Projekte (mit "[INTERN]" am Anfang) nach links sortieren
    open_projects.sort((a, b) => {
      const aIsInternal = a.project_name.startsWith('[INTERN]')
      const bIsInternal = b.project_name.startsWith('[INTERN]')
      if (aIsInternal && !bIsInternal) return -1
      if (!aIsInternal && bIsInternal) return 1
      return a.project_name.localeCompare(b.project_name)
    })

    this.updateMapStoreFeatures()
    this.openProjects = open_projects
    this.deselectInternalProjectOnInit();

  }

  private mapTicketToRowData(ticket: WPTicket): WPTicket & {actions: FaActionIcon[]} & {dispatcher_color?: string} {
    return {
      ...ticket,
      actions: [
        {
          icon: faBell,
          tooltip: 'Wiedervorlage aktivieren',
          action: () => {
            this.openTicketReviewDialog(ticket)
          },
          css_classes: ''
        }
      ],
      dispatcher_color: ticket.dispatcher
        ? (ticket.dispatcher.dispatcher_color || DISPATCHER_COLORS[this.activeDispatcher.findIndex(d => d.id == ticket.dispatcher.id) % DISPATCHER_COLORS.length])
        : undefined
    }
  }

  private deselectInternalProjectOnInit() {
    if (!this.firstProjectsInitialized) {
      this.firstProjectsInitialized = true
      const possible_internal_project = this.openProjects.find(p => p.project_name == '[INTERN] - Bentomax')
      if (possible_internal_project) {
        this.removeProjectFromSelection(possible_internal_project.project_name)
      }
    }
  }

  getProjectFilteredTickets(tickets: WPTicket[]): WPTicket[] {
    return tickets.filter(ticket => this.selectedProjects == 'all' || this.selectedProjects.includes(ticket.project.name))
  }

  selectReviewFilter(key: ReviewFilterSelection): void {
    this.selectedReviewFilter = key;
    this.updateShownTickets();
  }

  selectMaterialReviewFilter(key: ReviewFilterSelection): void {
    this.selectedMaterialReviewFilter = key;
    this.updateShownTickets();
  }

  getReviewFilteredTickets(tickets: WPTicket[], filterOverride?: ReviewFilterSelection): WPTicket[] {

    const activeFilter = filterOverride ?? this.selectedReviewFilter;
    const now = Date.now();
    const hasReview = (t: WPTicket) => t.review?.date;
    const ts = (t: WPTicket) => new Date(t.review?.date).getTime();

    const wantNoReviewOrReached   = activeFilter == 'off';
    const wantPlanned    = activeFilter == 'planned';

    return tickets.filter(t => {
      if (!hasReview(t)) return wantNoReviewOrReached;
      const time = ts(t);
      if (isNaN(time)) return false;
      return (wantNoReviewOrReached && time <= now) || (wantPlanned && time > now);
    });
  }

  selectKPITile(name: KPIFilter ): void {
    if (this.selectedKPITile == name) {
      this.selectedKPITile = "all"
    } else {
      this.selectedKPITile = name
    }
    this.updateShownTickets()
  }

  getKPIFilteredTickets(tickets: WPTicket[]): WPTicket[] {
    let res: WPTicket[]
    switch (this.selectedKPITile) {
      case '0sla': {
        res = this.filterTicketsForTimeUntilSLA(tickets, 0)
        break;
      }
      case '6sla': {
        res = this.filterTicketsForTimeUntilSLA(tickets, 2 * 60 * 60 * 1000, true)
        break;
      }
      case 'new': {
        res = this.filterNewTickets(tickets)
        break;
      }
      case 'qm': {
        res = this.filterQMTickets(tickets)
        break;
      }
      case 'overdue': {
        res = this.filterOverdueTickets(tickets)
        break;
      }
      case 'not_approached': {
        res = this.filterNotApproachedTickets(tickets)
        break;
      }
      default: {
        res = tickets
      }
    }
    return res
  }

  ticketIsUnplanned(ticket: WPTicket): boolean | Technician {
    return !ticket.planned_technician_id || ticket.planned_technician_id == 283 || this.placeholderTechnicians.find(technician => technician.id == ticket.planned_technician_id)
  }

  ticketIsNew(ticket: WPTicket): boolean {
    const created_date = new Date(ticket.date_created)
    const today_date = new Date()
    return  created_date.getDate() == today_date.getDate() && created_date.getMonth() == today_date.getMonth() && created_date.getFullYear() == today_date.getFullYear()
  }

  ticketIdRenderer(params) {
    const tid = params.data.id
    return `<a class="hover_link" href="/a/ticket/${tid}" rel="noopener">${params.value}</a>`
  }

  storeRenderer(params) {
    const store_id = params.data.store_id
    return `<a class="hover_link" href="/a/filiale/${store_id}" rel="noopener">${params.value}</a>`
  }

  reviewRenderer(params: { value: { reason: string, date: string } }) {
    const review = params?.value
    if (review) {
      return `Ab ${formatDate(new Date(review.date), 'dd.MM.yyyy HH:mm', 'de-De')}Uhr | Grund: ${review.reason}`
    }
    return ''
  }

  telephoneRenderer(params) {
    const phone = params.value
    return `<a href="tel:${phone ? phone.replaceAll(' ', '') : ''}" target="_blank" rel="noopener">${phone || ''}</a>`
  }

  emailRenderer(params) {
    const mail = params.value
    return `<a href="mailto:${mail}" target="_blank" rel="noopener">${mail || ''}</a>`
  }

  private prioCellRenderer2(params): string {
    return `<img src="/r/icons/priority/${params?.data?.priority?.color?.replace('#', '')}.svg"
              height="18" width="18" alt="priority_icon"
              aria-hidden="true" data-toggle="tooltip"
              title="${params.value}">`
  }

  dispatcherRenderer(params): string {
    const dispatcher = params?.data?.dispatcher;
    if (!dispatcher) {
      return '';
    }

    const initials = dispatcher.initials;

    return `<span style="
      display: inline-block;
      padding: 0 8px;
      border-radius: 4px;
      background-color: ${params?.data?.dispatcher_color};
      color: #000;
      font-weight: 600;
      font-size: 12px;
      height: calc(100% - 1px);
      width: calc(100% - 1px);
    " title="${dispatcher.full_name}">${initials}</span>`;
  }

  public operationDateRenderer(params): string {
    if (params.value) {
      return `${formatDate(params.value, "dd.MM.YYYY HH:mm", 'de-DE')}`
    } else {
      return ''
    }
  }

  toolTipListValueGetter(params: ITooltipParams<WPTicket, string[], any>){
    return (params.value == null || !params.value.length) ? "" : params.value.join(' | ');
  }

  onTicketGridReady(params: GridReadyEvent) {
    this.ticketGridApi = params.api
  }

  onMaterialTicketGridReady(params: GridReadyEvent) {
    this.materialTicketGridApi = params.api
  }

  onTechnicianGridReady(params: GridReadyEvent) {
    this.technicianGridApi = params.api
  }

  public ticketQuickSearchChanged(e: Event) {
    this.setTicketQuickFilterText((e.target as HTMLInputElement).value)
  }

  public technicianQuickSearchChanged(e: Event) {
    this.setTechnicianQuickFilterText((e.target as HTMLInputElement).value)
  }

  public setTicketQuickFilterText(text: string) {
    this.ticketGridApi.setGridOption(
      "quickFilterText",
      text,
    )
  }

  public setTechnicianQuickFilterText(text: string) {
    this.technicianGridApi.setGridOption(
      "quickFilterText",
      text,
    )
  }

  public materialTicketQuickSearchChanged(e: Event) {
    this.materialTicketGridApi.setGridOption(
      "quickFilterText",
      (e.target as HTMLInputElement).value,
    )
  }

  onTicketSelectionChanged() {
    this.selectedTicketIds = this.ticketGridApi.getSelectedRows().map(row => row.id);
    this.updateMapStoreFeatures()
  }

  onMaterialTicketSelectionChanged() {
    // Materialversand-Selektion hat keine Auswirkung auf Karte/Planungsassistent
  }

  onTechnicianSelectionChanged() {
    const new_selected_technician = this.technicianGridApi.getSelectedRows()[0]
    if (new_selected_technician) {
      this.selectedTechnician = new_selected_technician
      this.mapNavigation = {
        zoom: window.innerWidth <= 1920 ? 5.8 : 6.8,
        center: {
          lat: this.selectedTechnician.day_start_lat,
          lng: this.selectedTechnician.day_start_lon
        }
      }
      this.updateRouteVisualizationNodes()
    }
    if (this.mapTourFilter == 'selected') this.updateTourDisplayUnits()
  }

  selectTechnicianInTable(technician: WPTechnician, skip_tab_switch?: boolean): void {
    if (this.selectedTabIdx != 2 && !skip_tab_switch) this.selectedTabIdx = 2
    this.technicianGridApi.forEachNode(node => {
      if (node.data.full_name == technician.full_name) {
        this.technicianGridApi.setNodesSelected({nodes: [node], newValue: true})
        this.technicianGridApi.ensureIndexVisible(node.rowIndex)
      }
    })
  }

  toggleTicketTableSelection(ticket: WPTicket, skip_tab_switch?: boolean): void {
    if (this.selectedTabIdx != 0 && !skip_tab_switch) this.selectedTabIdx = 0

    let new_toggle_value: boolean
    this.ticketGridApi.forEachNode(node => {
      new_toggle_value = !node.isSelected()
      if (node.data.id == ticket.id) this.ticketGridApi.setNodesSelected({nodes: [node], newValue: new_toggle_value})
    })
    if (new_toggle_value) this.ticketGridApi.paginationGoToPage(Math.floor(this.ticketGridApi.getSelectedNodes()[0].rowIndex / this.ticketGridApi.paginationGetPageSize()))
  }


  openPlanningAssistant(only_load_tickets?: boolean): void {

    const loading_params = (this.selectedTechnician && !only_load_tickets) ?
      encodePlanTechnicianLoadingCaseParams(
        this.router,
        this.selectedTechnician.id,
        {
          ticket_ids: this.selectedTicketIds,
          project_ids: this.openProjects.filter(p => this.selectedProjects == 'all' || this.selectedProjects.includes(p.project_name)).map(p => p.id)
        }
      ) :
      encodePlanTicketsLoadingCaseParams(
        this.router,
        this.selectedTicketIds[0],
        {
          additional_ticket_ids: this.selectedTicketIds.slice(1),
          project_ids: this.openProjects.filter(p => this.selectedProjects == 'all' || this.selectedProjects.includes(p.project_name)).map(p => p.id)
        }
      )

    window.open(
      loading_params, '_blank'
    );
  }

  openTicketReviewDialog(ticket: WPTicket): void {
    this.reviewDialogTicket = ticket;
    this.showTicketReviewDialogForm = this.formBuilder.group({
      review_date: ['', [Validators.required, dateValidator]],
      review_reason: ['', [Validators.required]],
      ticket_id: [ticket.id, [Validators.required]],
    });
  }

  saveTicketReview(): void {
    if (this.showTicketReviewDialogForm?.valid) {
      const form_controls = this.showTicketReviewDialogForm.controls
      const review_date = new Date(form_controls.review_date.value).toISOString()
      const review_reason = form_controls.review_reason.value
      const ticket_id = form_controls.ticket_id.value
      this.ticketService.updateTicketReview(ticket_id, { review_date, review_reason }).subscribe(
        _ => {
          this.updateServiceTickets()
          this.closeReviewDialog()
        },
        error => {
          console.log(error)
        }
      )
    }
  }

  resetTicketReview(): void {
    if (this.reviewDialogTicket) {
      this.ticketService.resetTicketReview(this.reviewDialogTicket.id).subscribe(
        _ => {
          this.updateServiceTickets()
          this.closeReviewDialog()
        },
        error => {
          console.log(error)
        }
      )
    }
  }

  closeReviewDialog(): void {
    this.showTicketReviewDialogForm = null
    this.reviewDialogTicket = null
  }

  // Prüft ob das Ticket eine aktive Wiedervorlage hat (Datum in der Zukunft)
  hasActiveReview(): boolean {
    if (!this.reviewDialogTicket?.review?.date) return false
    return new Date(this.reviewDialogTicket.review.date).getTime() > Date.now()
  }

  selectAllProjects(): void {
    this.selectedProjects = 'all'
    this.updateShownTickets()
  }

  clickProject(project_name: string) {
    this.selectedProjects = [project_name]
    this.updateShownTickets()
  }

  addProjectToSelection(project_name: string) {
    if (this.selectedProjects != 'all') {
      this.selectedProjects = [... new Set<string>(this.selectedProjects.concat([project_name]))]
    }
    if (this.selectedProjects.length == this.openProjects.length) {
      this.selectedProjects = 'all'
    }
    this.updateShownTickets()
  }

  removeProjectFromSelection(project_name: string) {
    if (this.selectedProjects != 'all') {
      this.selectedProjects = this.selectedProjects.filter(p => p != project_name)
    } else {
      this.selectedProjects = this.openProjects.filter(p => p.project_name != project_name).map(p => p.project_name)
    }
    this.updateShownTickets()
  }

  private async updateTechnicianCapacityBars() {
     const bar_data = await Promise.all(
      this.shownTechnicians.map(async technician => {
        this.initAdditionalTechnicianData(technician)
        const data = await technician.tour.waitForBarData()
        data.external_idx = this.shownTechnicians.indexOf(technician)
        return data
      })
    )
    this.technicianBarData = bar_data.sort((bdata_a, bdata_b) => {
      return bdata_a.description < bdata_b.description ? -1 : 1
    })
    this.updateDeadlineNow()
  }

  private async updateTechnicianRouteNodes(technician: WPTechnician & AdditionalTechnicianTableData) {
    this.initAdditionalTechnicianData(technician)
    this.routeVisualizationNodes = await technician.tour.waitForRouteNodes()
  }

  private initAdditionalTechnicianData(technician: WPTechnician & AdditionalTechnicianTableData) {
    const local_day_ts = PATimeControl.Instance.dateToTimestamp(this.selectedDate(), true, false)
    if (!technician.tour) technician.tour = new TechnicianTour(technician, this.distanceCalculator, this.storeCollection, local_day_ts)
    if (!technician.links) technician.links = this.generateTechnicianIcons(technician)
  }

  private generateTechnicianIcons(technician: WPTechnician): FaLinkIcon[] {
    const res: FaLinkIcon[] = []

    if (technician.phone1) {
      res.push({
        icon: faPhone,
        css_classes: '',
        link: `tel:${technician.phone1 ? technician.phone1.replaceAll(' ', '') : ''}`,
        tooltip: `${technician.full_name} anrufen`
      })
    }

    if (technician.email1) {
      res.push({
        icon: faEnvelope,
        css_classes: '',
        link: `mailto:${technician.email1 ? technician.email1 : ''}`,
        tooltip: `E-Mail an ${technician.full_name} verfassen`
      })
    }

    res.push({
      icon: faRoute,
      link: encodePlanTechnicianLoadingCaseParams(this.router, technician.id),
      css_classes: '',
      tooltip: `${technician.full_name} im Planungsassistenten öffnen`
    })

    return res
  }

  private updateDeadlineNow(): void {
    const time_now = this.getHoursNow()

    const selected_local_day_ts = PATimeControl.Instance.dateToTimestamp(this.selectedDate(), true, false)
    const todays_local_day_ts = PATimeControl.Instance.dateToTimestamp(new Date(), true, false)

    const show_time = time_now < this.unitAmountEnd && this.unitAmountStart <= time_now && selected_local_day_ts == todays_local_day_ts
    this.deadlineNow = show_time ? { at_value: time_now, description: 'Jetzt', color: 'blue' } : null
  }

  private getHoursNow(): number {
    const date_now = new Date()
    return this.getHoursOnDate(date_now)
  }

  private getHoursOnDate(date: Date): number {
    const hour_now = date.getHours()
    const minute_now = date.getMinutes()
    return hour_now + (minute_now / 60)
  }

  changeBarOption(event: {idx: number, option: string, new_value: boolean}): void {
    const technician = this.shownTechnicians[event.idx]
    if (event.option == 'Reisetechniker') {
      if (event.new_value) {
        this.setTravelTechnicianDate(technician)
      } else {
        this.deleteTravelTechnicianDate(technician)
      }
    }
  }

  setTravelTechnicianDate(technician: WPTechnician): void {
    const date = new Date(this.selectedDate().getTime())

    const data = {
      user_id: technician.id,
      date: this.formatDate(date)
    }

    this.travelTechnicianDateService.createTravelTechnicianDate(data).subscribe(
      _ => {
        this.updateTechnicianData()
      },
      error => {
        console.log(error)
      }
    )
  }

  deleteTravelTechnicianDate(technician: WPTechnician): void {
    this.travelTechnicianDateService.deleteTravelTechnicianDate(technician.travel_technician_date_id).subscribe(
      _ => {
        this.updateTechnicianData()
      },
      err => {
        console.log(err)
      }
    )
  }

  formatDate(date: Date) {
    if (date) {
      return date.getFullYear() + '-' +
        ((date.getMonth() + 1).toString().padStart(2, '0')) + '-' +
        date.getDate().toString().padStart(2, '0') + 'T' +
        date.getHours().toString().padStart(2, '0') + ':' +
        date.getMinutes().toString().padStart(2, '0') + ':00'
    }

    return
  }

  private async updateRouteVisualizationNodes() {
    if (this.selectedTechnician) {
      await this.updateTechnicianRouteNodes(this.selectedTechnician)
    }
  }

  // get work time in minutes
  operationWorkTime(operation: WPOperation): number {
    if (operation.on_site && operation.finished) {
      return (new Date(operation.finished).getTime() - new Date(operation.on_site).getTime()) / (1000 * 60)
    } else {
      return operation.time_estimation
    }
  }

  operationsStartDayMinutes(operation: WPOperation): number {
    let use_date: Date
    if (operation.on_site) {
      use_date = new Date(operation.on_site)
    } else {
      use_date = new Date(operation.operation_date)
    }

    const on_site_timestamp = use_date.getTime()
    use_date.setHours(0)
    use_date.setMinutes(0)
    use_date.setMilliseconds(0)
    return (on_site_timestamp - use_date.getTime()) / (60 * 1000)
  }

  updateTableSizes($event: MatTabChangeEvent) {
    if ($event.index == 2) {
      this.technicianGridApi.sizeColumnsToFit()
    } else if ($event.index == 1 && this.materialTicketGridApi) {
      this.materialTicketGridApi.sizeColumnsToFit()
    } else {
      this.ticketGridApi.sizeColumnsToFit()
    }
  }

  onTechnicianRowDataUpdate() {
    const selected_technician_name = this.selectedTechnician?.full_name
    const new_selected_technician = this.shownTechnicians.find(t => t.full_name == selected_technician_name)
    if (new_selected_technician) {
      this.selectTechnicianInTable(new_selected_technician, true)
    }
  }

  protected readonly faWindowClose = faWindowClose;

  unselectTechnician() {
    this.selectedTechnician = null
    this.technicianGridApi.deselectAll()
  }

  private updateMapStoreFeatures() {
    const selected_map_stores: StoreMapboxFeatureInstance[]  = []
    const unselected_map_stores: StoreMapboxFeatureInstance[]  = []

    for (const ticket of this.shownTickets) {
      const possible_store = selected_map_stores.find(st => st.store.lat == ticket.lat && st.store.lng == ticket.lng)
      if (possible_store) {
        possible_store.addTicket(ticket)
      } else {
        const store_id = this.storeCollection.getStoreIdForCoordinates({lat: ticket.lat, lon: ticket.lng})
        const is_selected = !!this.selectedTicketIds.find(id => id == ticket.id)
        const store_feature_instance = new StoreMapboxFeatureInstance(
          {
            id: store_id,
            lat: ticket.lat,
            lng: ticket.lng,
            short_name: (ticket.store_name ? ticket.store_name.slice(0, 3).toUpperCase() : '?'),
            color: 'rgb(0,0,0)'
          },
          [ticket],
          {
            bg_color: is_selected ? 'rgb(15,164,220)' : undefined,
            font_color: is_selected ? 'rgb(255,255,255)' : undefined,
          }
        )
        if (is_selected) {
          selected_map_stores.push(store_feature_instance)
        } else {
          unselected_map_stores.push(store_feature_instance)
        }

        store_feature_instance.onClickListener = () => {
          this.toggleTicketTableSelection(ticket, true)
        }
      }
    }

    this.selectedMapStoreFeatureInstances = selected_map_stores
    this.unSelectedMapStoreFeatureInstances = unselected_map_stores
    this.updateStoreFeatureMapDisplayUnit()
  }

  private updateStoreFeatureMapDisplayUnit() {
    this.storeFeatureMapDisplayUnits = [
      new StoreFeatureMapDisplayUnit(this.selectedMapStoreFeatureInstances, {bg_color: 'rgb(51,121,182)', text_color: 'white'}),
      new StoreFeatureMapDisplayUnit(this.unSelectedMapStoreFeatureInstances, {bg_color: 'rgba(172,187,209,0.6)', text_color: 'black'})
    ]
    this.updateMapDisplayUnits()
  }

  public updateStoreStopoverDisplayUnits() {
    const filtered_technicians = this.getFilteredMapTourTechnicians()
    const shown_tours = filtered_technicians.map(t => t.tour)
    const shown_operations = shown_tours.reduce((ops: OperationWithStore[], tour) => ops.concat(tour.operations) , [])
    const shown_stores = [...new Set(shown_operations.map(op => this.storeCollection.getStore(op.storeId)).filter(s => s))]
    this.storeStopOverDisplayUnits = shown_stores.map(store => {
      const store_tours = shown_tours.filter(tour => tour.operations.find(op => op.storeId == store.id))
      const store_stopover_display_unit = new StoreStopoverMapDisplayUnit(
        store,
        store_tours,
        this.dynamicComponentService
      )
      store_stopover_display_unit.onClickListener = () => {
        if (store_tours.length) {
          const first_tour_technician = this.shownTechnicians.find(t => t.tour == store_tours[0])
          if (first_tour_technician) this.selectTechnicianInTable(first_tour_technician)
        }
      }
      return store_stopover_display_unit
    })
    this.updateMapDisplayUnits()
  }

  public updateTourAnimationDisplayUnits() {
    const filtered_technicians = this.getFilteredMapTourTechnicians()
    this.mapTourAnimationDisplayUnits = filtered_technicians.map(t =>
      {
        const tour_animation_display_unit = new TourAnimationMapDisplayUnit(t.tour)
        tour_animation_display_unit.onClickListener = () => {
          this.selectTechnicianInTable(t)
        }
        return tour_animation_display_unit
      }
    )
    this.updateMapDisplayUnits()
  }

  private getFilteredMapTourTechnicians() {
    return (this.mapTourFilter == 'selected' ? (this.selectedTechnician ? [this.selectedTechnician] : []) : this.shownTechnicians).filter(t => t.tour);
  }

  public updateTechnicianMapDisplayUnits(): void {
    const filtered_technicians = this.getFilteredMapTechnicians()
    this.technicianMapDisplayUnits = filtered_technicians.map(t => {
      const names = t.full_name.split(' ')
      const firstname = names.slice(0, names.length - 1).join(' ')
      const lastname = names[names.length - 1]
      const technician_map_display_unit = new TechnicianMapDisplayUnit(
        {
          firstname: firstname,
          lastname: lastname,
          id: t.id,
          lat: t.day_start_lat,
          lon: t.day_start_lon
        },
        t.tour ? t.tour.getColor(): 'white',
        t.tour && t.tour.operations?.length ? 'white' : 'black',
      )
      technician_map_display_unit.onClickListener = () => {
        this.selectTechnicianInTable(t)
      }
      return technician_map_display_unit
    })
    this.updateMapDisplayUnits()
  }

  private updateMapDisplayUnits() {
    let map_display_units: MapDisplayUnit<any[], any[]>[] = []
    map_display_units = map_display_units.concat(
      this.storeFeatureMapDisplayUnits
    ).concat(
      this.mapTourAnimationDisplayUnits
    ).concat(
      this.storeStopOverDisplayUnits
    ).concat(
      this.technicianMapDisplayUnits
    )
    this.mapDisplayUnits = map_display_units
  }

  private updateTechnicianTourColors() {
    let tour_count = 0
    for (const technician of this.shownTechnicians) {
      if (technician.tour && technician.tour.operations.length) {
        // Die am Benutzer hinterlegte Tourfarbe schlägt die Index-Farbe. Der Zähler
        // läuft trotzdem weiter, damit die automatisch vergebenen Farben der
        // übrigen Techniker gleich bleiben, sobald jemand eine feste Farbe bekommt.
        technician.tour.setColor(technician.tour_color || PAUtil.getIndexColorString(tour_count))
        tour_count += 1
      } else {
        technician.tour.setColor('rgba(255,255,255, .6)')
      }
    }
    this.shownTechnicians = [...this.shownTechnicians] // update table data
  }

  private getFilteredMapTechnicians(): (WPTechnician & AdditionalTechnicianTableData)[] {
    switch (this.mapTechnicianFilter) {
      case 'with_tour': {
        return this.shownTechnicians.filter(t => t.day_operations.length)
      }
      case 'not_absent': {
        return this.shownTechnicians.filter(t => !t.day_absence)
      }
      default: {
        return [...this.shownTechnicians]
      }
    }
  }

  updateTourDisplayUnits() {
    this.updateStoreStopoverDisplayUnits();
    this.updateTourAnimationDisplayUnits();
  }

  protected readonly faPlusCircle = faPlusCircle;
  protected readonly faMinusCircle = faMinusCircle;
  protected readonly faUser = faUser;
  protected readonly faWrench = faWrench;
  protected readonly faTicket = faTicket;
  protected readonly faBox = faBox;
  protected readonly faChevronDown = faChevronDown;
  technicianTabWasSelected: boolean = false;
  getTicketRowId = (params: { data: WPTicket }) => String(params.data.id);

  tabChange($event: MatTabChangeEvent) {
    this.updateTableSizes($event)
    if (this.selectedTabIdx == 2) {
      this.technicianTabWasSelected = true;
      this.capacityBarsCollapsed = true;
    } else {
      this.capacityBarsCollapsed = false;
    }
  }

  public saveTicketFilterState() {
    const state = this.ticketGridApi.getState()
    delete state['filter']
    delete state.pagination.page
    const serializedState = JSON.stringify(state)
    localStorage.setItem(this.ticketStorageKey, serializedState)
  }

  public deleteTicketFilterState() {
    localStorage.removeItem(this.ticketStorageKey)
  }

  public saveTechnicianFilterState() {
    const state = this.technicianGridApi.getState()
    delete state['filter']
    delete state.pagination.page
    const serializedState = JSON.stringify(state)
    localStorage.setItem(this.technicianStorageKey, serializedState)
  }

  public deleteTechnicianFilterState() {
    localStorage.removeItem(this.technicianStorageKey)
  }

  public saveMaterialTicketFilterState() {
    const state = this.materialTicketGridApi.getState()
    delete state['filter']
    delete state.pagination.page
    const serializedState = JSON.stringify(state)
    localStorage.setItem(this.materialTicketStorageKey, serializedState)
  }

  public deleteMaterialTicketFilterState() {
    localStorage.removeItem(this.materialTicketStorageKey)
  }

  public getTicketState(): GridState {
    return JSON.parse(localStorage.getItem(this.ticketStorageKey))
  }

  public getTechnicianState(): GridState {
    return JSON.parse(localStorage.getItem(this.technicianStorageKey))
  }

  public getMaterialTicketState(): GridState {
    return JSON.parse(localStorage.getItem(this.materialTicketStorageKey))
  }

  private initTableStates() {
    this.initialTicketState = this.getTicketState()
    this.initialMaterialTicketState = this.getMaterialTicketState()
    this.initialTechnicianState = this.getTechnicianState()
  }

  private getSelectedDatesRegionalTechnicianHolidays(technician: WPTechnician & AdditionalTechnicianTableData) {
    const selected_date = this.selectedDate()
    if (technician.country.toLowerCase().replaceAll(' ', '') == 'deu' && selected_date) {
      const selected_local_day_ts = PATimeControl.Instance.dateToTimestamp(selected_date, true, false)
      const holiday_state = PATimeControl.Instance.germanStatesTranslations[technician.state]
      return PATimeControl.Instance.getTimestampsHolidays(selected_local_day_ts, holiday_state)
    } else {
      return []
    }
  }

  parseDateToDayString(date: Date): string {
    if (date) {
      const local_day_ts = PATimeControl.Instance.dateToTimestamp(date, true, false)
      const todays_day_ts = PATimeControl.Instance.dateToTimestamp(new Date, true, false)
      if (local_day_ts == todays_day_ts) return 'Datenauswahl: Heute'
      if (local_day_ts == todays_day_ts + 24 * 60 * 60 * 1000) return 'Datenauswahl: Morgen'

      const date_string = PATimeControl.Instance.dateToDatestring(date, false, false,'.')
      const weekday = PATimeControl.Instance.weekDayToGermanName(PATimeControl.Instance.getTimeStampsWeekDay(local_day_ts), true)
      return 'Datenauswahl: ' + weekday + ' ' + date_string
    }
  }

  private buildDateAtSixLocal(offsetDays: number): Date {
    const d = new Date();
    d.setHours(6, 0, 0, 0);        // 06:00:00.000 heute
    d.setDate(d.getDate() + offsetDays);
    return d;
  }

  setReviewDateTomorrow(): void {
    const d = this.buildDateAtSixLocal(1);
    this.showTicketReviewDialogForm?.get('review_date')?.setValue(d);
    this.showTicketReviewDialogForm?.get('review_date')?.markAsDirty();
    this.showTicketReviewDialogForm?.get('review_date')?.markAsTouched();
  }

  setReviewDateIn3Days(): void {
    const d = this.buildDateAtSixLocal(3);
    this.showTicketReviewDialogForm?.get('review_date')?.setValue(d);
    this.showTicketReviewDialogForm?.get('review_date')?.markAsDirty();
    this.showTicketReviewDialogForm?.get('review_date')?.markAsTouched();
  }

  setReviewDateIn1Week(): void {
    const d = this.buildDateAtSixLocal(7);
    this.showTicketReviewDialogForm?.get('review_date')?.setValue(d);
    this.showTicketReviewDialogForm?.get('review_date')?.markAsDirty();
    this.showTicketReviewDialogForm?.get('review_date')?.markAsTouched();
  }
}

function dateValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return null; // required prüft separat
  const date = new Date(value);
  return isNaN(date.getTime()) ? { invalidDate: true } : null;
}
